import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';

export interface FormSelectOption {
    key: any;
    label: string;
}

export interface FormInputProps {
    help?: string;
    id: string,
    label: string;
    name: string;
    onChange: (v: any) => void;
    options: FormSelectOption[];
    required?: boolean;
    value: string | undefined;
}

export const FormSelect: FunctionComponent<FormInputProps> = observer((p) =>
    <div className="form-group">
        <label
            htmlFor={p.id}>
            {p.label}
        </label>
        <div className="relative">
            <select
                id={p.id}
                name={p.name}
                onChange={e => p.onChange(e.target.value)}
                value={p.value}
            >
                {p.options.map(o =>
                    <option
                        key={p.id + o.key}
                        value={o.key}>{o.label}
                    </option>
                )}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                <FontAwesomeIcon className="fill-current ml-4 text-m-gray-6" icon={faChevronDown} />
            </div>
        </div>
        {p.help && <p className="input-hint">{p.help}</p>}
    </div>
);
